export default "__VITE_ASSET__ff9f4707__"